import { TimePicker } from '@mui/x-date-pickers'
import dayjs, { Dayjs } from 'dayjs'
import { FC, useRef } from 'react'

interface Props {
  label: string
  onChange: (data: any) => void
  value?: Dayjs | null
  fullWidth?: boolean
  ampm?: boolean
  error?: boolean
  helperText?: React.ReactNode
  required?: boolean
  validate?: () => void
  autoFillMinutes?: boolean
}

export const CustomTimePicker: FC<Props> = ({
  label,
  onChange,
  value,
  fullWidth,
  ampm,
  error,
  helperText,
  required,
  validate,
  autoFillMinutes,
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <TimePicker
      ampm={ampm}
      value={value}
      label={label}
      onChange={onChange}
      onClose={() => {
        validate?.()
      }}
      sx={{ width: fullWidth ? '100%' : undefined }}
      slotProps={{
        textField: {
          inputRef: inputRef,
          variant: 'outlined',
          helperText: error ? helperText : '',
          error: error,
          sx: { width: '100%' },
          required: required,
          onBlur: () => validate?.(),
          onInput: () =>
            autoFillMinutes
              ? queueMicrotask(() => {
                  const input = inputRef.current
                  if (!input) return

                  const raw = input.value
                  const digits = raw.replaceAll(/\D/g, '')

                  if (digits.length === 1 || digits.length === 2) {
                    const hour = Number.parseInt(digits, 10)

                    if (hour >= 0 && hour <= 23) {
                      const newVal = dayjs().hour(hour).minute(0).second(0)
                      onChange(newVal)

                      const text = digits.padStart(2, '0') + ':00'
                      input.value = text

                      input.setSelectionRange(3, 3)
                    }
                  }
                })
              : null,
        },
      }}
    />
  )
}
